'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (block) {
  var text = block.getText();
  var hasEmptyText = text.length === 0;
  var blockType = block.getType();
  var isListItemBlock = blockType === 'unordered-list-item' || blockType === 'ordered-list-item';

  return isListItemBlock && hasEmptyText;
};


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/draft-js-list-depth-plugin/lib/utils/isEmptyListItem.js
// module id = 965
// module chunks = 0